/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetEntraConsentLinkRequest
 */
export interface GetEntraConsentLinkRequest {
    /**
     * 
     */
    tenantId: string;
}

/**
 * Check if a given object implements the GetEntraConsentLinkRequest interface.
 */
export function instanceOfGetEntraConsentLinkRequest(value: object): value is GetEntraConsentLinkRequest {
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    return true;
}

export function GetEntraConsentLinkRequestFromJSON(json: any): GetEntraConsentLinkRequest {
    return GetEntraConsentLinkRequestFromJSONTyped(json, false);
}

export function GetEntraConsentLinkRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetEntraConsentLinkRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': json['tenantId'],
    };
}

export function GetEntraConsentLinkRequestToJSON(json: any): GetEntraConsentLinkRequest {
    return GetEntraConsentLinkRequestToJSONTyped(json, false);
}

export function GetEntraConsentLinkRequestToJSONTyped(value?: GetEntraConsentLinkRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenantId': value['tenantId'],
    };
}

